import { createFileRoute } from '@tanstack/react-router';

import { TravelRequestBrowse } from '@/module/Travel/Request/TravelRequestBrowse';

export const Route = createFileRoute('/_auth/travel/_travel/requests/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TravelRequestBrowse />;
}
